<template>
  <div class="repwd_container">
    <div v-show="showStep1">
      <div class="title">
        忘记密码
      </div>
      <van-form @submit="nextStep">
        <van-field
          v-model="captchaForm.mobile"
          placeholder="请输入手机号"
          autocomplete="new-password"
          class="field_item"
        />

        <van-field
          v-model="captchaForm.code"
          placeholder="请输入验证码"
          autocomplete="new-password"
          class="field_item "
        >
          <template #button>
            <span class="code" @click="getCode" v-if="state.smsSendBtn">
              获取验证码
            </span>
            <span v-else class="code2">
              {{ '(' + state.time + 's)后重新发送' }}
            </span>
          </template>
        </van-field>

        <div class="pwd_btn">
          <van-button
            round
            block
            type="info"
            native-type="submit"
            color="#F93244"
            :disabled="!captchaForm.mobile || !captchaForm.code"
          >
            下一步
          </van-button>
        </div>
      </van-form>
    </div>
    <div v-show="showStep2">
      <div class="title">
        重置密码
      </div>
      <van-form @submit="onSubmit">
        <van-field
          v-model="rePwdForm.password"
          placeholder="请输入新密码"
          autocomplete="new-password"
          class="field_item"
          type="password"
        />

        <van-field
          v-model="rePwdForm.rePassword"
          placeholder="再次确认密码"
          autocomplete="new-password"
          class="field_item"
          type="password"
        >
        </van-field>

        <div class="pwd_btn">
          <van-button
            round
            block
            type="info"
            native-type="submit"
            color="#F93244"
            :disabled="!rePwdForm.password || !rePwdForm.rePassword"
          >
            确认
          </van-button>
        </div>
      </van-form>
    </div>
    <div class="action_btn">
      <span class="red" @click="openLink('/register')">立即注册 </span> |
      <span @click="openLink('/rePwd')">忘记密码</span>
    </div>
  </div>
</template>

<script>
import { sipSms, sipFindPassword } from '@/api';
import Vue from 'vue';
import { ACCESS_TOKEN } from '@/store/mutation-types';

export default {
  data() {
    return {
      captchaForm: {
        mobile: '',
        code: ''
      },
      rePwdForm: {
        password: '',
        rePassword: ''
      },
      state: {
        time: 60,
        smsSendBtn: true
      },
      showStep1: true,
      showStep2: false
    };
  },
  methods: {
    openLink(path) {
      if (path == '/register' && Vue.ls.get('inviterCode')) {
        this.$router.push({
          path,
          query: {
            c: Vue.ls.get('inviterCode')
          }
        });
      } else {
        this.$router.push(path);
      }
    },

    getCode() {
      const { state, captchaForm } = this;
      if (!captchaForm.mobile.trim()) {
        return this.$toast.fail('请输入手机号');
      }
      if (!/^1[3456789]\d{9}$/.test(captchaForm.mobile)) {
        return this.$toast.fail('请输入正确的手机号');
      }
      state.smsSendBtn = false;
      const interval = window.setInterval(() => {
        if (state.time-- <= 0) {
          state.time = 60;
          state.smsSendBtn = true;
          window.clearInterval(interval);
        }
      }, 1000);
      sipSms(captchaForm.mobile, 2)
        .then((res) => {
          if (res.success) {
            this.$toast.success('验证码获取成功');
          } else {
            this.$toast.fail(res.msg);
          }
        })
        .catch((err) => {
          clearInterval(interval);
          state.time = 60;
          state.smsSendBtn = true;
          this.$toast.fail(err.message);
        });
    },
    nextStep() {
      this.showStep1 = false;
      this.showStep2 = true;
    },

    onSubmit() {
      const { captchaForm, rePwdForm } = this;
      const params = Object.assign(captchaForm, rePwdForm);
      sipFindPassword(params)
        .then((res) => {
          if (res.success) {
            this.$toast.success('修改密码成功，请前往登录');
            setTimeout(() => {
              this.$router.push('/login');
            }, 1000);
          } else {
            this.$toast.fail(res.msg);
          }
        })
        .catch((err) => {
          console.log('err', err);
        });
    }
  }
};
</script>

<style lang="less" scoped>
.repwd_container {
  padding: 19.733vw 0;
  .red {
    color: #f93244;
  }
  .title {
    padding-left: 4.267vw;
    font-size: 7.467vw;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 8.533vw;
  }
  .field_item {
    height: 14.933vw;
    margin-bottom: 4.267vw;
    display: flex;
    align-items: center;
    font-size: 4.533vw;
    color: rgba(0, 0, 0, 0.25);
    .code {
      font-size: 4.533vw;
      color: #f93244;
      padding: 6px 10px;
    }
    .code2 {
      font-size: 4.533vw;
      color: rgba(0, 0, 0, 0.45);
    }
  }

  .pwd_btn {
    padding: 24.533vw 4.267vw 5.333vw;
  }
  .action_btn {
    text-align: center;
    color: rgba(0, 0, 0, 0.25);
    font-size: 3.733vw;
  }
}
</style>
